import React, { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";
import { AppState, Auth0Provider } from "@auth0/auth0-react";

interface AuthContainerProps {
  children: React.ReactNode;
}

const AuthContainer = ({
  children,
}: PropsWithChildren<AuthContainerProps>): JSX.Element | null => {
  const navigate = useNavigate();

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
  const redirect_uri = process.env.REACT_APP_AUTH0_CALLBACK_URL;

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  // TODO - Handle this better, should it show an error page?
  if (!(domain && clientId && audience && redirect_uri)) {
    console.log(
      "AuthContainer is not properly configured. Please check app config and retry.",
    );
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: audience,
        redirect_uri: redirect_uri,
      }}
      onRedirectCallback={onRedirectCallback}
      // cacheLocation="localstorage"
      // useRefreshTokens={true}
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthContainer;
